import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Popup from '../../../common/Popup';
import * as irActions from '../../../../redux/actions/irSearch';
import DocketDetailsPurchaseForm from '../DocketDetailsPurchaseForm';


class DownloadZipAllPdfsRangePopup extends Component {
  componentDidUpdate(prevProps) {
    if (!prevProps.docketParts.alreadyPurchased && this.props.docketParts.alreadyPurchased) {
      this.downloadPdfZip();
    }
  }

  buy = () => {
    if (this.props.dispatch(irActions.checkClientCodeValid())) {
      this.props.dispatch(irActions.buyAllParts(this.props.popup.data)).then(() => this.downloadPdfZip());
    } else {
      this.props.onClose();
    }
  }

  downloadPdfZip = () => {
    this.props.dispatch(irActions.downloadPdfZip(this.props.popup.data))
      .then(this.props.reloadDetails);
  }

  render() {
    const { popup, onClose, docketParts } = this.props;

    return (
      <Popup show={popup.show}
             clsName="docket-pdf-zip-popup"
             topBarTitle="Download PDFs in a Zip File"
             onClose={onClose}>
        <DocketDetailsPurchaseForm
          docketParts={docketParts}
          buy={this.buy} />
      </Popup>
    );
  }
}

DownloadZipAllPdfsRangePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  docketParts: PropTypes.object.isRequired,
  popup: PropTypes.object.isRequired,
  reloadDetails: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { popup, docketParts, favoriteEmail } = state.get('dockets').toJS();

  return {
    popup,
    docketParts,
    favoriteEmail,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadZipAllPdfsRangePopup);



/** WEBPACK FOOTER **
 ** ./src/components/case/docket/popups/DownloadZipAllPdfsRangePopup.jsx
 **/